import Vue from 'vue'

const ENTITY_SET_NAME =(state, payload)=> {
            
    state.data.name = payload
};

const ENTITY_SET_NUMBER =(state, payload)=> {
            
    state.data.number = payload
};

const ENTITY_SET_ENTITYCATEGORY =(state, payload)=> {
    
    state.data.entitycategory_id = payload       
    
};

const ENTITY_SET_SPECIFICATION =(state, payload)=> {
    
    state.data.specification_id = payload       
};

const ENTITY_SET_TAGS =(state, payload)=> {
    console.log(payload)
    state.data.tag_ids = payload
};

const ENTITY_SET_SUPPLIER =(state, payload)=> {
        
    state.data.supplier_id = payload
};

const ENTITY_SET_COMPANIES =(state, payload)=> {
            
    state.data.company_ids = payload
};

const ENTITY_SET_RECIPESTEPS =(state, payload)=> {
            
    state.data.recipesteps = payload
};

const ENTITY_SET_LOGOS =(state, payload)=> {
            
    state.data.logo_ids = payload
};

const ENTITY_SET_DUPLICATE =(state, payload)=> {
            
    state.data.duplicate = payload
};

const ENTITY_SET_ENTITIES =(state, payload)=> {

    state.entities=payload
};

const ENTITY_SET_INGREDIENTS =(state, payload)=> {
    state.ingredients=[]
    state.ingredients=payload
};

const ENTITY_SET_ENTITY =(state, payload)=> {

        
        state.data.name=payload.name
        state.data.number=payload.number
        state.data.specification_id=payload.specification_id
        state.data.entitycategory_id=payload.entitycategory_id
        state.data.tag_ids=payload.tags.map(t=>t.tag_id)
        state.data.company_ids=payload.companies.map(c=>c.company_id)
        state.data.supplier_id=payload.supplier_id
        state.data.recipesteps=payload.recipesteps
        state.data.logo_ids=payload.logos.map(l=>l.id)
        state.data.logos=payload.logos

};

const ENTITY_INIT_ENTITY =(state)=> {

        state.data.name=""
        state.data.number=""
        state.data.specification_id=null
        state.data.entitycategory_id=null
        state.data.supplier_id=null
        state.data.tag_ids=[]
        state.data.recipesteps=[]
        state.data.logo_ids=[]

};
const ENTITY_SET_SHOWRESULT =(state,payload)=> {

        state.showresult=state.entities.find(a=>a.id==payload)

};

export default {
    ENTITY_SET_NAME,
    ENTITY_SET_NUMBER,
    ENTITY_SET_ENTITYCATEGORY,
    ENTITY_SET_SPECIFICATION,
    ENTITY_SET_TAGS,
    ENTITY_SET_RECIPESTEPS,
    ENTITY_SET_DUPLICATE,
    ENTITY_SET_ENTITIES,
    ENTITY_SET_INGREDIENTS,
    ENTITY_SET_ENTITY,
    ENTITY_INIT_ENTITY,
    ENTITY_SET_LOGOS,
    ENTITY_SET_SHOWRESULT,
    ENTITY_SET_SUPPLIER
};